import axios from '@axios'
export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {

        getDestinations(ctx, data) {
            return new Promise((resolve, reject) => {
              axios
                .post('/review/v1/destination/getDestinations', data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

        addDestination(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/review/v1/destination/addDestination`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },

        updateDestination(ctx, data){
            const id = data.id
            
            return new Promise((resolve, reject) => {
                axios
                    .post(`/review/v1/destination/update/${id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        deleteDestination(ctx, id){
            return new Promise((resolve, reject) => {
            axios
                .delete(`/review/v1/destination/delete/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

        getReviews(ctx, data) {
            return new Promise((resolve, reject) => {
              axios
                .post('/review/v1/getReviews', data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

        addReview(ctx, queryParams){ 
            return new Promise((resolve, reject) => {
              axios
                .post('/review/v1/addReview', queryParams, {
                    headers:{
                        'Content-Type': 'multipart/form-data',
                        'dataType':'json'
                    }
                })
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

        updateReview(ctx, queryParams){
             return new Promise((resolve, reject) => {
               axios
                 .post(`/review/v1/update/${queryParams.id}` ,queryParams.formData,{
                   headers:{
                     'Content-Type': 'multipart/form-data',
                     'dataType':'json'
                   }
                 })
                 .then(response => resolve(response))
                 .catch(error => reject(error))
             })
         },

        getReviewGallery(ctx, queryParams){
            const data = JSON.stringify(queryParams);

            return new Promise((resolve, reject) => {
                axios
                    .post('/review/v1/gallery/getGallery', data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        addReviewGallery(ctx, queryParams){
            const id  = queryParams.id

            return new Promise((resolve, reject) => {
                axios
                    .post(`/review/v1/gallery/add/${id}`, queryParams.formData)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        updateOrdering(ctx, queryParams){
            const data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
                axios
                    .post('/review/v1/gallery/updateOrdering', data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        deteleReviewGallery(ctx, id){
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/review/v1/gallery/delete/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        updateReviewOrdering(ctx, queryParams) {
            const data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
              axios
                .post('/review/v1/updateOrdering', data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

        deleteReview(ctx, id){
            return new Promise((resolve, reject) => {
              axios
                .delete(`/review/v1/delete/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
    }
}